import React from 'react'
import clsx from 'clsx'
import { ls } from '../../../locale'

import type { FlightFareType } from '../../../state/models/flight'
import { FarePrice, BaseFarePrice } from './FarePrice'
import { CheckRadio } from '../../../comps/checkbox';

import { FareItemBox, FareItemDetail, FareItemDetailWithInfo } from './FareItemBox';
import { TagBox } from '../../../comps/tagbox'


export function FareItem({fare, currencyCode, selected, onClick}: {fare: FlightFareType, currencyCode: string, selected: boolean, onClick?: (fareSellKey: string) => void}) {

  const fareTypeName = fare.fareTypeName.replace(/ /g, '');
  const rFareType = ls.t('FareType')[fareTypeName]
  if(!rFareType) return null;
  const onlineCheckinLabel = rFareType.OnlineCheckin?.Label ?? ls.t('FareType.Common.OnlineCheckin.Label');
  
  const rFareRule = ls.t('FareRule');
  const rFlightPage = ls.t('FlightPage');

  const { fareWithTaxes, fareSellKey, baseFareWithTaxes } = fare.fareInfos[0];

  const handleFareClick = () => {
    if (typeof onClick === 'function') {
      onClick(fareSellKey)
    }
  }

  return (

    <div className={clsx('tw-group tw-grid tw-grid-rows-subgrid tw-row-span-12 tw-border tw-border-solid tw-border-t-0 md:tw-border-t tw-text-center',
      'tw-cursor-pointer',
      'md:tw-mb-2',
      'hover:tw-border-blue-sa hover:tw-shadow-outline-blue hover:tw-bg-[#f8f8f6]',
      selected ? 'tw-border-blue-sa tw-shadow-outline-blue tw-bg-[#f8f8f6]' : 'tw-border-[#81b43f]' )}
      onClick={handleFareClick}
    >
      {/* title for desktop */}
      <div className={clsx('tw-hidden tw-p-2 tw-relative md:tw-flex tw-flex-col tw-items-center tw-justify-center tw-min-h-[60px]',
        "tw-bg-[url('./images/fare-header.png')] tw-bg-cover tw-bg-no-repeat tw-bg-center",
        // 'group-hover:tw-text-white group-hover:tw-bg-blue-sa',
        selected ? 'tw-text-white tw-bg-blue-sa' : '')}
      >
        <div className="tw-font-bold tw-text-white tw-text-lg tw-uppercase">{rFareType.Label}</div>
        {fare.fareCategory !== 'omanis' && fare.fareTypeName === 'Value' && <TagBox>{rFlightPage.MostPopolar}</TagBox>}
        {fare.fareCategory === 'omanis' && <TagBox>{rFlightPage.OmanisOnly}</TagBox>}
      </div>
      {/* title for mobile */}
      <div className={clsx('tw-flex md:tw-hidden tw-flex-row tw-gap-3 tw-items-center tw-justify-between tw-p-3',
        selected ? 'tw-bg-blue-sa tw-text-white' : 'sa-text-green'
      )}
      >
        <div className={clsx('tw-grow tw-text-start tw-text-2xl tw-font-[500]')}>
          <div className="tw-inline-block">{rFareType.Label}</div>
          {fare.fareCategory !== 'omanis' && fare.fareTypeName === 'Value' && <TagBox>{rFlightPage.MostPopolar}</TagBox>}
          {fare.fareCategory === 'omanis' && <TagBox>{rFlightPage.OmanisOnly}</TagBox>}
        </div>
        <FarePrice isFree={fare.isFree} currencyCode={currencyCode} amount={fareWithTaxes} />
        <CheckRadio checked={selected} color={selected ? 'white' : 'blue'} />
      </div>
      <div className={clsx('md:tw-grid tw-grid-rows-subgrid tw-row-span-11', selected ? 'tw-grid' : 'tw-hidden')}>
        <FareItemBox>
          <FareItemDetailWithInfo label={rFareRule.HandLuggage.Label} notes={rFareRule.HandLuggage?.Notes} icon='handbag' tooltipId={'handLuggage' + fare.fareTypeName}>{rFareType.HandLuggage?.Label}</FareItemDetailWithInfo>
        </FareItemBox>
        <FareItemBox>
          <FareItemDetailWithInfo label={rFareRule.CarryOnLuggage.Label} notes={rFareRule.CarryOnLuggage?.Notes} icon='carryon' tooltipId={'carryOnLuggage' + fare.fareTypeName}>{rFareType.CarryOnLuggage?.Label}</FareItemDetailWithInfo>
        </FareItemBox>
        <FareItemBox>
          <FareItemDetail label={rFareRule.CheckInLuggage.Label} icon='checkedbag'>{rFareType.CheckInLuggage?.Label}</FareItemDetail>
        </FareItemBox>
        <FareItemBox>
          <FareItemDetail label={rFareRule.PriorityCheckin.Label} icon='priority'>{rFareType.PriorityCheckin?.Policy}</FareItemDetail>
        </FareItemBox>
        <FareItemBox><FareItemDetail label={rFareRule.Seat.Label} icon='seat'>{rFareType.Seat?.Label}</FareItemDetail></FareItemBox>
        <FareItemBox>
          <FareItemDetailWithInfo label={rFareRule.Meal.Label} icon='meal' tooltipId={'meal' + fare.fareTypeName}>{rFareType.Meal?.Policy}</FareItemDetailWithInfo>
        </FareItemBox>
        <FareItemBox>
          <FareItemDetail label={rFareRule.OnlineCheckin.Label} icon='online'>{onlineCheckinLabel}</FareItemDetail>
        </FareItemBox>
        <FareItemBox>
          <FareItemDetail label={rFareRule.CounterCheckin.Label} icon='counter'>{rFareType.CounterCheckin?.Label}</FareItemDetail>
        </FareItemBox>
        <FareItemBox>
          <FareItemDetailWithInfo label={rFareRule.ChangeFlight.Label} icon='change' tooltipId={'changePolicy' + fare.fareTypeName.replace(/ /g, "")}>{rFareType.ChangeFlight?.Policy}</FareItemDetailWithInfo>
        </FareItemBox>
        <FareItemBox hideBottomLineInMobile={true}>
          <FareItemDetailWithInfo label={rFareRule.CancelFlight.Label} icon='cancellation' tooltipId={'cancelPolicy' + fare.fareTypeName.replace(/ /g, "")}>{rFareType.CancelFlight?.Policy}</FareItemDetailWithInfo>
        </FareItemBox>
        <div className='tw-hidden tw-p-2 md:tw-flex tw-flex-col tw-items-center sa-text-green'>
          <FarePrice isFree={fare.isFree} currencyCode={currencyCode} amount={fareWithTaxes} />
          { baseFareWithTaxes > fareWithTaxes && <BaseFarePrice currencyCode={currencyCode} amount={baseFareWithTaxes} /> }
          <div className='md:tw-mt-2'>
          <CheckRadio checked={selected} color={selected ? 'blue' : 'white'} />
          </div>
        </div>
      </div>
    </div>
  )
}
